import { render } from "./UserAccountDetails.vue?vue&type=template&id=04760510"
import script from "./UserAccountDetails.vue?vue&type=script&lang=js"
export * from "./UserAccountDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__